import {ExperienceLevel, ProfileSkill, Skill} from "@betrue/shared/interfaces";
import {SKILLS} from "./skills.dataset";
import {randomData, randomEnum} from "./helpers.dataset";
import { v4 as uuidv4 } from 'uuid';

export const PROFILE_SKILLS = randomData<Skill>(SKILLS, 10).map((skill) => ({
  id:uuidv4(),
  skill: skill,
  experienceLevel: randomEnum(ExperienceLevel)
})) as ProfileSkill[]
